import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import EcoPageHeader from "../../../components/eco-page-header/EcoPageHeader";
import { useGoBack } from "../../../hooks/useGoBack";

import AccountsSettings from "../components/AccountsSettings";
import CategoriesSettings from "../components/CategoriesSettings";
import CounterpartiesSettings from "../components/CounterpartiesSettings";
import RecurrencesSettings from "../components/RecurrencesSettings";
import { FINANCEIRO_PAGE } from "../routes";
import { useFinPermissions } from "../utils/fin";
import "../../dp/pages/Dp.css";
import "../../dp/pages/DpEco.css";
import "./Financeiro.css";

const TABS = [
  { key: "contas", label: "Contas bancárias" },
  { key: "categorias", label: "Plano de contas" },
  { key: "contrapartes", label: "Fornecedores e clientes" },
  { key: "repeticoes", label: "Repetições" },
] as const;

type TabKey = (typeof TABS)[number]["key"];

/** Cadastros do Financeiro em abas; a aba fica na URL (`?aba=`) para ter link próprio. */
export default function FinSettingsPage() {
  const navigate = useNavigate();
  const goBack = useGoBack(FINANCEIRO_PAGE());
  const { token, canWrite } = useFinPermissions();
  const [params, setParams] = useSearchParams();

  const tab: TabKey = TABS.some((t) => t.key === params.get("aba")) ? (params.get("aba") as TabKey) : "contas";

  return (
    <div className="dpePage">
      <main className="dpePage__main">
        <EcoPageHeader
          crumbs={[{ label: "Financeiro", onClick: () => navigate(FINANCEIRO_PAGE()) }, { label: "Cadastros" }]}
          title="Cadastros do Financeiro"
          subtitle="Contas bancárias, plano de contas, fornecedores e clientes, e repetições."
          onBack={goBack}
          backLabel="Voltar ao Financeiro"
          actions={!canWrite ? <span className="ecoPill ecoPill--off">Somente leitura</span> : undefined}
        />

        <nav className="dpTabs" aria-label="Cadastros">
          {TABS.map((t) => (
            <button
              key={t.key}
              type="button"
              className={`dpTab ${tab === t.key ? "is-active" : ""}`}
              aria-current={tab === t.key ? "page" : undefined}
              onClick={() => setParams({ aba: t.key }, { replace: true })}
            >
              {t.label}
            </button>
          ))}
        </nav>

        {tab === "contas" ? <AccountsSettings token={token} canWrite={canWrite} /> : null}
        {tab === "categorias" ? <CategoriesSettings token={token} canWrite={canWrite} /> : null}
        {tab === "contrapartes" ? <CounterpartiesSettings token={token} canWrite={canWrite} /> : null}
        {tab === "repeticoes" ? <RecurrencesSettings token={token} canWrite={canWrite} /> : null}
      </main>
    </div>
  );
}
